export enum RecordTypeEnum {
  Accreditation = 'accreditation',
  Qualification = 'qualification',
  Classification = 'classification',
  Programme = 'programme',
  Standard = 'standard',
  StandardGroup = 'standard-group',
  MicroCredential = 'micro-credential',
  CMR = 'cmr',
  Consent = 'consent',
  RuleGroup = 'rule-group'
}

export enum RecordTypeDisplayEnum {
  Accreditation = 'Accreditation',
  Qualification = 'Qualification',
  Classification = 'Classification',
  Programme = 'Programme',
  Standard = 'Standard',
  StandardGroup = 'Standard Group',
  MicroCredential = 'Micro-credential',
  CMR = 'CMR',
  Consent = 'Consent',
  RuleGroup = 'Rule Group'
}

export enum RecordTypeNumericEnum {
  Qualification = 1,
  Classification = 2,
  Programme = 3,
  Standard = 4,
  StandardGroup = 5,
  MicroCredential = 6,
  CMR = 7,
  Consent = 8,
  Accreditation = 9,
  RuleGroup = 10
}

export enum RecordStatusEnum {
  Draft = 'Draft',
  Current = 'Current',
  Expiring = 'Expiring',
  Discontinued = 'Discontinued',
  Withdrawn = 'Withdrawn',
  Declined = 'Declined'
}

export enum VersionStatusEnum {
  Draft = 1050,
  Approved = 1051,
  Superseded = 1052,
  Withdrawn = 1053,
  Declined = 1054,
  Discontinued = 1055,
  Expiring = 1056
}

export enum RecordSortEnum {
  DateModifiedDesc = 1000,
  NumberAsc = 1001,
  NumberDesc = 1002,
  TitleAsc = 1003,
  TitleDesc = 1004
}
